import type { TOC } from '@ember/component/template-only';

import styles from './skeleton.module.css';

interface GeneralSkeletonSignature {
  Args: {};
  Element: HTMLDivElement;
}

const GeneralSkeleton = <template>
  <div aria-hidden="true" class={{styles.pulse}} ...attributes></div>
</template> satisfies TOC<GeneralSkeletonSignature>;

export default GeneralSkeleton;
